import { Box } from '@mui/material';

import { normalizeSx } from '@/shared/lib/normalizeSx';

import type { Sx } from '@/shared/types/uiTypes';

type TagTone = 'default' | 'new';

/**
 * A small uppercase pill label. Omit `tone` to keep the label-based colors
 * (the `beta` label is muted; anything else uses the primary highlight). Use
 * `tone="new"` for the catalog "NEW" launch badge.
 */
type TagProps = {
  label?: string;
  variant?: 'default' | 'large';
  /** Color scheme. `default` keeps the legacy label-based colors. */
  tone?: TagTone;
  sx?: Sx;
};

const variantSx: Record<'default' | 'large', Sx> = {
  default: {},
  large: { height: 20, px: '6px', fontSize: 10, fontWeight: 600 }
};

const toneSx: Record<TagTone, Sx> = {
  default: {},
  new: {
    backgroundColor: 'gx.tagNewBg',
    color: 'gx.tagNewText',
    fontSize: '12px',
    fontWeight: 700,
    height: '14px',
    minWidth: 'unset',
    px: '6px'
  }
};

const labelSx: Sx = {
  display: 'block',
  lineHeight: 1,
  position: 'relative'
};

export const Tag = ({ label = 'beta', variant = 'default', tone = 'default', sx }: TagProps) => {
  return (
    <Box
      sx={[
        {
          backgroundColor: label === 'beta' ? 'gx.actionBarButtonTile' : 'gx.highlight',
          fontSize: '8px',
          textTransform: 'uppercase',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          lineHeight: 1,
          px: '4px',
          minWidth: '36px',
          letterSpacing: 0,
          height: '12px'
        },
        ...normalizeSx(variantSx[variant]),
        ...normalizeSx(toneSx[tone]),
        ...normalizeSx(sx)
      ]}
    >
      <Box
        component='span'
        sx={labelSx}
      >
        {label}
      </Box>
    </Box>
  );
};
